export default function (announcement) {
  return {
    title: announcement.Announcment_Title,
    body: announcement.Announcement_Body,
    image: announcement.Image,
    url: announcement.External_Link,
    objectFit: announcement.Image_Fit || 'cover',
    objectPosition: announcement.Image_Position || 'center',
    showFade: announcement.Show_Background_Fade || false,
    fadeColor: announcement.Background_Fade_Color || '',
    titleColor: announcement.Title_Color || '#000',
    bodyColor: announcement.Body_Color || '#000',
    buttonText: announcement.Link_Button_Text || '',
    buttonVariant: announcement.Button_Variant || 'primaryDarkened',
    buttonSize: announcement.Button_Size || 'xxsmall',
    buttonRoundness: announcement.Button_Roundness || 'small'
  };
}
